"use strict";

import config from '../configLoader';
import spxStyle from './ContentStyle';
import spxScript from './ContentScript';
import htmlContent from './ContentHtml';
import textObject from "../texts";

export default class Content {

	constructor(linkId)	{
		this.linkId = linkId;
		this.uri = config("services.sparxpres.uri");
		this.informationEndpoint = config("services.sparxpres.endpoints.information");
		this.xpresPayEndpoint = config("services.sparxpres.endpoints.xprespay");
	}

	/**
	 * Load content
	 * @param params
	 */
	getInformationContent(params)	{
		const urlParameters = new URLSearchParams(params);
		return getContentFromRemote(this.uri + this.informationEndpoint, urlParameters);
	}

	/**
	 * Get XpresPay page content
	 */
	getXpresPayInformationContent(params) {
		const urlParameters = new URLSearchParams(params);
		return getContentFromRemote(this.uri + this.xpresPayEndpoint, urlParameters);
	}

	/**
	 * Get content
	 * @param wrapper
	 * @param type
	 */
	getContent(wrapper = '', type = '') {
		return Promise.resolve(viewContent[wrapper][type]);
	}
}


function getContentFromRemote(url, urlParameters) {
	const _url = url + "?" + urlParameters.toString();

	return fetch(_url, {
		method: 'GET'
	})
		.then(response => {
			if (response.status !== 200) {
				throw new Error("Trying to load content, HTTP status " + response.status);
			}
			return response.json();
		})
		.then(data => data);
}


const viewContent = {
	"simple": {
		"plain": {
			"html": {
				"finance": htmlContent.simple.header + htmlContent.common.content + htmlContent.simple.footer,
				"xprespay": htmlContent.common.xprespay,
			},
			"style": spxStyle.plain,
			"script": spxScript.plain
		},
		"dropdown": {
			"html": {
				"finance": htmlContent.simple.header + htmlContent.common.content + htmlContent.simple.footer,
				"xprespay": htmlContent.common.xprespay,
			},
			"style": spxStyle.dropdown,
			"script": spxScript.dropdown
		},
		"slider": {
			"html": {
				"finance": htmlContent.simple.header + htmlContent.common.content + htmlContent.simple.footer,
				"xprespay": htmlContent.common.xprespay,
			},
			"style": spxStyle.slider,
			"script": spxScript.slider
		},
		"xprespay": {
			"html": {
				"finance": "",
				"xprespay": htmlContent.common.xprespay,
			},
			"style": spxStyle.xprespay,
			"script": ""
		}
	},
	"modal": {
		"plain": {
			"html": {
				"finance": htmlContent.modal.header + htmlContent.common.content + htmlContent.modal.footer,
				"xprespay": htmlContent.common.xprespay,
			},
			"style": spxStyle.plain,
			"script": spxScript.plain
		},
		"dropdown": {
			"html": {
				"finance": htmlContent.modal.header + htmlContent.common.content + htmlContent.modal.footer,
				"xprespay": htmlContent.common.xprespay,
			},
			"style": spxStyle.dropdown,
			"script": spxScript.dropdown
		},
		"slider": {
			"html": {
				"finance": htmlContent.modal.header + htmlContent.common.content + htmlContent.modal.footer,
				"xprespay": htmlContent.common.xprespay,
			},
			"style": spxStyle.slider,
			"script": spxScript.slider
		}
	},
	"checkout": {
		"xprespay": {
			"title": "XpresPay",
			"html": `
				<div class="sparxpres-container">
					<div class="sparxpres-paragraph">Du betaler med XpresPay ved at klikke på knappen nedenfor og følge vejledningen. Herefter kan du gennemføre købet.</div>
					<span class="sparxpres-modal-open" onclick="window.dispatchEvent(new Event('sparxpresLoanApplicationOpen'));">Betal med XpresPay</span>
				</div>
				`,
			"style": spxStyle.checkout + spxStyle.modal,
			"script": spxScript.checkout
		},
		"finance": {
			"title": "Sparxpres delbetaling",
			"html": `
				<div class="sparxpres-container">
					<div class="sparxpres-paragraph">Du ansøger om Sparxpres delbetaling ved at klikke på knappen nedenfor og følge vejledningen. Herefter kan du gennemføre købet.</div>
					<span class="sparxpres-modal-open" onclick="window.dispatchEvent(new Event('sparxpresLoanApplicationOpen'));">Ansøg om delbetaling</span>
				</div>
				`,
			"style": spxStyle.checkout + spxStyle.modal,
			"script": spxScript.checkout
		},
		"both": {
			"title": "Sparxpres delbetaling / XpresPay",
			"html": `
				<div class="sparxpres-container">
					<div class="sparxpres-paragraph">Du ansøger om Sparxpres delbetaling eller betaler med XpresPay, ved at klikke på knappen nedenfor og følge vejledningen. Herefter kan du gennemføre købet.</div>
					<span class="sparxpres-modal-open" onclick="window.dispatchEvent(new Event('sparxpresLoanApplicationOpen'));">Ansøg om delbetaling / Betal med XpresPay</span>
				</div>
				`,
			"style": spxStyle.checkout + spxStyle.modal,
			"script": spxScript.checkout
		},
		"alert" : {
			"title": "Sparxpres delbetaling / XpresPay",
			"html": `
				<div class="sparxpres-alert">
					<div class="sparxpres-alert-cell">
						${textObject.checkout.loanApplication.DECLINE.svgIcon}
					</div>
					<div class="sparxpres-alert-cell sparxpres-paragraph">
						${textObject.checkout.amount.invalid}
					</div>
				</div>
				`,
			"style": spxStyle.checkout,
			"script": ""
		}
	}
}
